
export default class JurisdictionModel {
  constructor() {
    this._data = {
      autospin: true,
      netposition: true,
      timeElapse: true,
      turbo: true,
    }
  }

  get() {
    return this._data
  }

  set(value) {
    this._data.autospin = value.autospin ? value.autospin.visible : true
    this._data.netposition = value.netposition ? value.netposition.visible : true
    this._data.timeElapse = value.timeElapse ? value.timeElapse.visible : true
    this._data.turbo = value.turbo ? value.turbo.visible : true
  }
}
